/**
 * Sanitizes a promo code by removing all spaces,
 * uppercasing, and allowing only a-z A-Z 0-9 - _.
 *
 * @param {string} value The promo code.
 * @returns {string} The sanitized promo code.
 */
export const sanitizePromoCode = (value = '') => {
  return value.replace(/[^A-Z0-9-_]/gi, '').toUpperCase();
};
